import { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { createSnapQuoteLineAttachment } from '../endpoints/create-snap-quote-line-attachment';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';

function createSnapQuoteLineAttachmentFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof createSnapQuoteLineAttachment.Types.ResultType>,
) {
  const { snapQuoteLineUuid } = action.payload;

  const createdByDisplayName = {
    displayName: action.payload.createdBy?.displayName ?? 'unknown',
  };

  const snapQuoteLine = getQuoteLineOrThrow(state, snapQuoteLineUuid);

  snapQuoteLine.documentIds.push(action.payload.id);
  snapQuoteLine.documents[action.payload.id] = {
    id: action.payload.id,
    fileName: action.payload.fileName,
    fileType: action.payload.fileType,
    createdBy: createdByDisplayName,
    createdAt: action.payload.createdAt,
  };
}

export function createSnapQuoteLineAttachmentReducer(
  builder: ExtraReducerBuilder,
) {
  builder.addMatcher(
    createSnapQuoteLineAttachment.matchFulfilled,
    withSaveStateUpdate(createSnapQuoteLineAttachmentFulfilled),
  );
}
